import React from "react";
const ThemeContext = React.createContext({});
const ThemeProvider = ({ theme = {}, children }) => /* @__PURE__ */ React.createElement(ThemeContext.Provider, { value: theme }, children);
const useTheme = () => React.useContext(ThemeContext);
export {
  ThemeProvider,
  useTheme
};
//# sourceMappingURL=theme-provider.js.map
